import type { LitEvents } from './types';

export const EVENTS: LitEvents = {
  onNavigate: 'navigate',
  onProfileSwitch: 'profile-switch'
} as const;
